<template>
  <div>
    <Dialog :commonDialog="dDialog" :dialogWidth="dialogWidth">
      <template v-slot:title>
        <v-layout>
          <v-flex> Manage Position </v-flex>
          <v-flex class="text-right">
            <v-btn
              depressed
              small
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="createContractType"
            >
              <span class="font-size-16 font-weight-600">Add position</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:body>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <v-form
            ref="ticketCollecttionForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="updateContractSetting"
          >
            <v-container class="py-0">
              <v-row class="py-0">
                <v-col md="12" class="py-0">
                  <table class="width-100">
                    <tbody>
                      <tr v-for="(type, index) in positions" :key="index">
                        <td>
                          <v-text-field
                            v-model.trim="type.text"
                            dense
                            filled
                            label="Position"
                            solo
                            flat
                            class="px-4 py-2"
                            hide-details
                            :disabled="pageLoading"
                            :loading="pageLoading"
                            :rules="[
                              validateRules.required(
                                type.text,
                                'Position Name'
                              ),
                            ]"
                            color="cyan"
                          ></v-text-field>
                        </td>
                        <td width="50" v-if="positions.length > 1">
                          <v-tooltip top content-class="custom-top-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-on:click="openDeleteDialog(index, type)"
                                color="deep-orange"
                                v-bind="attrs"
                                v-on="on"
                                >mdi-delete</v-icon
                              >
                            </template>
                            <span>Click here to delete</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </perfect-scrollbar>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="pageLoading || !formValid"
          :loading="pageLoading"
          class="mx-2 custom-grey-border custom-bold-button white--text"
          color="cyan"
          v-on:click="updateContractSetting"
        >
          Save
        </v-btn>
        <v-btn
          depressed
          :disabled="pageLoading"
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="$emit('close-dialog', true)"
        >
          Close
        </v-btn>
      </template>
    </Dialog>

    <DeleteConfirmTemplate :delete-dialog="deleteConfirm">
      <template v-slot:title>Delete Confirmation</template>
      <template v-slot:text>
        <h3 class="font-size-16 font-weight-500 delete-text">
          Once you delete
          <span class="font-weight-700"
            >{{ removePosition?.text }} Position</span
          >, you won't be able to retrieve this later.<br />Are you sure you
          want to delete
          <span class="font-weight-700"
            >{{ removePosition?.text }} Position</span
          >
          ?
        </h3>
      </template>
      <template v-slot:action>
        <v-btn
          class="mx-2 custom-grey-border custom-bold-button"
          v-on:click="deleteConfirm = false"
          >No! Cancel</v-btn
        >
        <v-btn
          color="red lighten-1 white--text"
          v-on:click="deleteProductType()"
          class="mx-2 custom-grey-border custom-bold-button"
          >Yes! Delete</v-btn
        >
      </template>
    </DeleteConfirmTemplate>
  </div>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";
import DeleteConfirmTemplate from "@/view/pages/partials/Delete";
export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    dDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    e_positions: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
  },
  watch: {
    e_positions: {
      deep: true,
      immediate: true,
      handler(param) {
        this.positions = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      formValid: true,
      pageLoading: false,
      removePosition: null,
      removeIndex: false,
      deleteConfirm: false,
      positions: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    updateContractSetting() {
      const _this = this;

      const formErrors = _this.validateForm(_this.$refs.ticketCollecttionForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }

      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/position",
          data: { positions: _this.positions },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-positions", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },

    deleteProductType() {
      this.positions.splice(this.removeIndex, 1);
      this.deleteConfirm = false;
    },

    openDeleteDialog(index, row) {
      this.removeIndex = index;
      this.removePosition = row;
      this.deleteConfirm = true;
    },
    createContractType() {
      this.positions.push({
        text: null,
      });
    },
  },
  components: {
    Dialog,
    DeleteConfirmTemplate,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
